import {Model} from './model';
import {Unserializer} from './serialization';

export class CreditInsurance implements Model {
  creditInsuranceId: number;
  endCustomerId: number;
  amount: number;
  validFrom: Date;
  validTo?: Date;
  note: string;

  static copy(oldObj: CreditInsurance): CreditInsurance {
    const newObj = new CreditInsurance();
    newObj.creditInsuranceId = oldObj.creditInsuranceId;
    newObj.endCustomerId = oldObj.endCustomerId;
    newObj.amount = oldObj.amount;
    newObj.validFrom = Unserializer.date(oldObj.validFrom);
    newObj.validTo = Unserializer.date(oldObj.validTo);
    newObj.note = oldObj.note;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.creditInsuranceId;
  }

  isNew(): boolean {
    return isNaN(this.creditInsuranceId);
  }

  clone(): CreditInsurance {
    return CreditInsurance.copy(this);
  }
}
